export default{
    tukeExplore: {
        accountChain: 'Account chain',
        bussnessChain: 'Business chain',
        posChain: 'PoS chain',
        enterTheThinkiumDAPPWebAddress: 'Enter Dapp URL',
        favorites: 'Favorites',
        noDappCollection: "You haven't favorited DApp, go to favorite~",
        openDappAndCollect: 'Open the DApp and click [Favorites] in the upper right corner.',
        recommend: 'Recommended',
        Organization: 'Organization',
        orgDesc: 'Join your organization',
        go:'Go',
    },
}